import {
  Activity,
  BadgeCheck,
  BookOpen,
  CalendarClock,
  Cpu,
  Diff,
  FlaskConical,
  GitCompare,
  HelpCircle,
  LayoutDashboard,
  ListChecks,
  Package,
  PlayCircle,
  ScrollText,
  Settings,
  Shield,
  ShieldCheck,
  SlidersHorizontal,
  Users,
  Waves,
  type LucideIcon,
} from "lucide-react";
import type { Role } from "@/api/types";
import type { Flag } from "../flags";

export interface NavItem {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  section: "testing" | "insights" | "admin" | "bottom";
  roles?: Role[];
  flag?: Flag;
  primary?: boolean;
  badge?: "pending";
}

export const NAV: NavItem[] = [
  { id: "dashboard", label: "Dashboard", to: "/", icon: LayoutDashboard, section: "testing" },
  { id: "newRun", label: "New run", to: "/runs/new", icon: PlayCircle, section: "testing", roles: ["TESTER", "ADMIN"], primary: true },
  { id: "runs", label: "Runs", to: "/runs", icon: Activity, section: "testing" },
  { id: "catalog", label: "Test catalog", to: "/catalog", icon: ListChecks, section: "testing" },
  { id: "profiles", label: "Profiles", to: "/profiles", icon: SlidersHorizontal, section: "testing" },
  { id: "artifacts", label: "Agent builds", to: "/artifacts", icon: Package, section: "testing" },
  { id: "compare", label: "Compare runs", to: "/compare", icon: GitCompare, section: "insights", flag: "compare" },
  { id: "certification", label: "Certification", to: "/certification", icon: BadgeCheck, section: "insights", flag: "certification" },
  { id: "flaky", label: "Flaky tests", to: "/insights/flaky", icon: Waves, section: "insights", flag: "flaky" },
  { id: "schedules", label: "Schedules", to: "/schedules", icon: CalendarClock, section: "insights", flag: "schedules" },
  { id: "payloadDiff", label: "Payload diff", to: "/insights/payload-diff", icon: Diff, section: "insights", flag: "payloadDiff" },
  { id: "admin", label: "Admin dashboard", to: "/admin", icon: Shield, section: "admin", roles: ["ADMIN"] },
  { id: "adminUsers", label: "Users", to: "/admin/users", icon: Users, section: "admin", roles: ["ADMIN"], badge: "pending" },
  { id: "adminAudit", label: "Audit log", to: "/admin/audit", icon: ScrollText, section: "admin", roles: ["ADMIN"] },
  { id: "adminSettings", label: "Installation settings", to: "/admin/settings", icon: Cpu, section: "admin", roles: ["ADMIN"] },
  {
    id: "adminMachines",
    label: "Machines",
    to: "/admin/machines",
    icon: FlaskConical,
    section: "admin",
    roles: ["ADMIN"],
    flag: "machines",
  },
  { id: "adminWaivers", label: "Waivers", to: "/admin/waivers", icon: ShieldCheck, section: "admin", roles: ["ADMIN"], flag: "waivers" },
  { id: "settings", label: "Settings", to: "/settings", icon: Settings, section: "bottom" },
  { id: "help", label: "Help", to: "/help", icon: HelpCircle, section: "bottom" },
];

export const SECTION_LABEL = { testing: "Testing", insights: "Insights", admin: "Admin", bottom: "" } as const;

export function visibleNav(role: Role | undefined, enabled: (f: Flag) => boolean): NavItem[] {
  return NAV.filter((n) => (!n.roles || (role && n.roles.includes(role))) && (!n.flag || enabled(n.flag)));
}

export const DOCS_ICON = BookOpen;
